import { render, staticRenderFns } from "./statTotals.vue?vue&type=template&id=75f5aeb6&"
import script from "./statTotals.vue?vue&type=script&lang=js&"
export * from "./statTotals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports